<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">納入場所グループ検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load" v-permit.SHARP_WG_SEARCH class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0171/new" v-permit.SHARP_WG_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_WG_EDIT.SHARP_WG_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-permit.SHARP_WG_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="グループCD" v-model="query.code"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="グループ分名" v-model="query.name"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="items"
        :rows-per-page-items="[10]"
        class="elevation-0"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.locales.ja_JP }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {},
  data: () => ({
    query: {
      code: '',
      name: ''
    },
    items: [],
    selected: [],
    headers: [
      { text: 'グループCD', value: 'code', sortable: false },
      { text: 'グループ名', value: 'name', sortable: false }
    ]
  }),
  methods: {
    load() {
      this.$storeParams()
      this.$http.get('/warehouse-groups', { params: this.query }).then(res => {
        this.items = res.data
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0171',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/warehouse-groups/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
    //this.load()
  }
}
</script>
